module.exports = __webpack_public_path__ + "static/media/logo-icon.74d94712.png";